<template>
  <div class="l-contentmain contentmain">
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <page-nav-bar
      v-else
      :is-sticky="true"
      :back-button="true"
      :hide-separators="true"
      :has-actions="false">
      <span slot="title">{{ program.name }}</span>
      <span slot="subtitle"> - Gestion de la Publication</span>
    </page-nav-bar>
    <page-content>
      <div v-if="!loading">
        <tabs
          class="has-background-white is-border-bottom"
          :level="0">
          <li
            v-if="mgcEnabled"
            :class="{'is-active' : panel === 'MULTIDIFF'}">
            <a
              @click="changePanel('MULTIDIFF')"
              class="">
              <span class="">Multi diffusion</span>
            </a>
          </li>
          <li :class="{'is-active' : panel === 'MINISITE'}">
            <a
              @click="changePanel('MINISITE')"
              class="">
              <span class="">Mini-site</span>
            </a>
          </li>
        </tabs>
        <div v-if="panel === 'MULTIDIFF' && diffusion">
          <form action="#">
            <div>
              <div class="has-background-dark is-padding-left is-padding-right">
                <div class="has-text-white is-size-6 is-padding-top-xxsmall is-padding-bottom-xxsmall">
                  <span class="icon is-small is-size-7 is-margin-right-xxsmall">
                    <i class="fas fa-check-circle"></i></span>
                  <i>Information obligatoire pour la validation du formulaire</i>
                </div>
              </div>
            </div>
            <div class="is-padding has-background-white">
              <div class="column is-12 title is-3 is-marginless">
                <h2 class="is-margin-bottom-xsmall">
                  Paramètre de diffusion
                </h2>
                <div class="is-size-4 has-text-grey">
                  Sélectionnez le ou les supports de diffusion de votre annonce
                </div>
              </div>
              <div class="is-size-7 has-background-warning is-padding-small is-radius">
                <div class="is-uppercase">
                  Les supports qui remontent sont ceux pour lesquels vous disposez d'une possibilité de diffusion d'annonce.
                </div>
                <div class="is-uppercase">
                  Le temps de mise en ligne de votre annonce est différent en fonction du support de diffusion. La durée peut varier de 12 à 24 heures<sup>*</sup>.
                </div>
              </div>
              <div class="is-padding-top">
                <div class="is-padding-bottom">
                  <r-label
                    :label="'Supports'"
                    :green-check="hasSupports"
                    :value="diffusion.supports"></r-label>
                  <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
                    <div
                      class="column is-4 is-3-widescreen"
                      v-for="origin in originsdMultidiff"
                      :key="origin.pk">
                      <input
                        type="checkbox"
                        class="vadCheckradiocase is-fullwidth"
                        v-model="diffusion.supports"
                        :value="origin.pk"
                        @change="checkSupports"
                        :name="origin.pk"
                        :id="origin.pk">
                      <label
                        class="is-nowrap"
                        :for="origin.pk"><div class="truncate"><div><span :title="origin.name">{{ origin.name }}</span><span
                          v-if="origin.parent_name"
                          :title="origin.parent_name">&nbsp;- {{ origin.parent_name }}</span></div></div></label>
                    </div>
                  </div>
                </div>
                <div class="columns is-multiline">
                  <div class="column is-6">
                    <date-picker
                      :model="diffusion.start_date"
                      @input="diffusion.start_date = $event"
                      class="is-self-centered"
                      :input-class="'is-fullwidth'"
                      :style-version="2"
                      :is-required="false"
                      label="Date de début de publication"></date-picker>
                  </div>
                  <div class="column is-6">
                    <date-picker
                      :model="diffusion.end_date"
                      @input="diffusion.end_date = $event"
                      class="is-self-centered"
                      :input-class="'is-fullwidth'"
                      :style-version="2"
                      :is-required="false"
                      label="Date de fin de publication"></date-picker>
                  </div>
                </div>
              </div>
              <div class="is-margin-top">
                <div class="title is-3 is-marginless">
                  <h2 class="is-margin-bottom-xsmall">
                    Détail de l'annonce
                  </h2>
                </div>
                <div class="column is-12 is-padding has-background-light is-border">
                  <a
                    v-if="program.descriptions && program.descriptions.length"
                    @click="addprogramDescription"
                    class="button is-margin-bottom-small is-primary">
                    <span>
                      Inclure les textes de descritpion du {{ nameToUse }}
                    </span>
                  </a>
                  <div
                    v-else
                    class="has-text-danger is-size-4 is-margin-bottom-small">
                    Ce {{ nameToUse }} ne contient pas de description
                  </div>
                  <div class="columns column is-12">
                    <div class="column is-6">
                      <r-label
                        :is-required="true"
                        :label="'Description courte (maximum 255 caractères)'"
                        :value="diffusion.short_description"></r-label>
                      <textarea
                        id="short_description"
                        name="short_description"
                        v-model="diffusion.short_description"
                        label="Description courte"
                        data-vv-value-path="val"
                        v-validate="'required|max:255'"
                        data-vv-as="Description courte"
                        class="textarea"
                        rows="7"
                        maxlength="255">
                      </textarea>
                    </div>
                    <div class="column is-6">
                      <r-label
                        :label="'Description longue'"
                        :is-required="false"
                        :value="diffusion.long_description"></r-label>
                      <textarea
                        id="long_description"
                        name="long_description"
                        v-model="diffusion.long_description"
                        label="Description longue"
                        data-vv-value-path="val"
                        data-vv-as="Description longue"
                        class="textarea"
                        rows="7">
                      </textarea>
                    </div>
                  </div>
                  <a
                    v-if="program.pictures && program.pictures.length"
                    @click="addProgramPictures"
                    class="button is-primary is-margin-bottom-small">
                    <span v-if="loadingImg">
                      <i class="fas fa-spinner fa-spin"></i>
                    </span>
                    <span v-else>
                      Inclure les images du {{ nameToUse }}
                    </span>
                  </a>
                  <div
                    v-else
                    class="has-text-danger is-size-4">
                    Ce {{ nameToUse }} ne contient pas d'image
                  </div>
                  <div class="field">
                    <label class="label">Téléchargez des images</label>
                    <upload-file
                      :multiple="true"
                      @upload="uploadDocument({ files: $event })"
                      :placeholder="'Sélectionnez ou déposez documents'"
                      :source-documents="pictures"
                      :for-mgc-diffusion="true"
                      @deleteDocument="deleteDocuments"></upload-file>
                  </div>
                </div>
              </div>
              <div class="is-margin-top">
                <div class="title is-3 is-marginless">
                  <h2 class="is-margin-bottom-xsmall">
                    Offre commerciale
                  </h2>
                </div>
              </div>
              <div class="">
                <div
                  v-for="(offer, idx) in offers"
                  class="has-background-light is-border is-padding-right is-padding-bottom is-padding-left is-margin-bottom"
                  :key="idx">
                  <div class="has-text-right">
                    <a
                      class="button is-circle is-border is-margin-right is-margin-neg-top is-white"
                      @click="removeOffer(idx)">
                      <i class="fas fa-trash-alt"></i>
                    </a>
                  </div>
                  <div class="columns is-multiline">
                    <div class="column is-6">
                      <r-label
                        :label="'Référence'"
                        :is-required="false"
                        :value="offer.reference"></r-label>
                      <v-input
                        :id="'reference-' + idx"
                        :name="'reference-' + idx"
                        @input="val => offer.reference = val"
                        :model="offer.reference"
                        placeholder="ex: CNLP"
                        :errors-bag="errors"
                        data-vv-value-path="val"
                        data-vv-as="Référence">
                      </v-input>
                    </div>
                    <div class="column is-6">
                      <r-label
                        :label="'Nom'"
                        :is-required="false"
                        :value="offer.name"></r-label>
                      <v-input
                        :id="'name-' + idx"
                        :name="'name-' + idx"
                        @input="val => offer.name = val"
                        :model="offer.name"
                        placeholder="ex: Campagne Nationale Loi Pinel"
                        label="Nom"
                        :errors-bag="errors"
                        data-vv-value-path="val"
                        data-vv-as="Nom">
                      </v-input>
                    </div>
                    <div class="column is-6">
                      <r-label
                        :label="'Date de début'"
                        :is-required="false"
                        :value="offer.start_date"></r-label>
                      <v-input
                        :id="'start_date-' + idx"
                        :name="'start_date-' + idx"
                        @input="val => offer.start_date = val"
                        :model="offer.start_date"
                        :placeholder="datePlaceholder"
                        label="Date de début"
                        :errors-bag="errors"
                        data-vv-value-path="val"
                        data-vv-as="Date de début">
                      </v-input>
                    </div>
                    <div class="column is-6">
                      <r-label
                        :label="'Date de fin'"
                        :is-required="false"
                        :value="offer.end_date"></r-label>
                      <v-input
                        :id="'end_date-' + idx"
                        :name="'end_date-' + idx"
                        @input="val => offer.end_date = val"
                        :model="offer.end_date"
                        :placeholder="datePlaceholder"
                        label="Date de fin"
                        :errors-bag="errors"
                        data-vv-value-path="val"
                        data-vv-as="Date de fin">
                      </v-input>
                    </div>
                    <div class="column is-12">
                      <r-label
                        :label="'Accroche de l\'offre'"
                        :is-required="false"
                        :value="offer.abstract"></r-label>
                      <textarea
                        :id="'abstract-' + idx"
                        :name="'abstract-' + idx"
                        v-model="offer.abstract"
                        label="Accroche"
                        data-vv-value-path="val"
                        data-vv-as="Accroche"
                        class="textarea"
                        rows="1">
                      </textarea>
                    </div>
                    <div class="column is-12">
                      <r-label
                        :label="'Description de l\'offre'"
                        :is-required="false"
                        :value="offer.description"></r-label>
                      <textarea
                        :id="'description-' + idx"
                        :name="'description-' + idx"
                        v-model="offer.description"
                        label="Description"
                        data-vv-value-path="val"
                        data-vv-as="Description"
                        class="textarea"
                        rows="3">
                      </textarea>
                    </div>
                    <div class="column is-12">
                      <r-label
                        :label="'Mentions Légales'"
                        :is-required="false"
                        :value="offer.legal_notice"></r-label>
                      <textarea
                        :id="'legal_notice-' + idx"
                        :name="'legal_notice-' + idx"
                        v-model="offer.legal_notice"
                        label="Mentions Légales"
                        data-vv-value-path="val"
                        data-vv-as="Mentions Légales"
                        class="textarea"
                        rows="3">
                      </textarea>
                    </div>
                  </div>
                </div>
                <div class="has-background-light is-padding is-border">
                  <a
                    @click="addOffer"
                    class="button is-white is-border is-rounded is-transform-none is-padding-right-large is-padding-left-large">
                    <span class="icon is-small has-text-grey"><i class="fas fa-plus-square"></i></span><span>Ajouter une offre promotionnelle</span>
                  </a>
                </div>
              </div>
              <div class="is-padding-bottom is-margin-top">
                <div class="title is-3 is-marginless">
                  <h2 class="is-margin-bottom-xsmall">
                    Informations de contact
                  </h2>
                </div>
                <div class="is-size-7 has-background-warning is-padding-small is-radius">
                  <div>Les informations "contacts" sont présentes dans l'annonce sur le support de publication</div>
                </div>
              </div>
              <div class="is-padding has-background-light is-border">
                <div class="columns is-multiline">
                  <div class="column is-4">
                    <r-label
                      :label="'Contact'"
                      :is-required="false"
                      :value="diffusion.contact"></r-label>
                    <v-input
                      id="contact"
                      name="contact"
                      @input="val => diffusion.contact = val"
                      :model="diffusion.contact"
                      placeholder="ex: Jacques DUPONT"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Contact">
                    </v-input>
                  </div>
                  <div class="column is-4">
                    <r-label
                      :label="'Horaires'"
                      :is-required="false"
                      :value="diffusion.schedule"></r-label>
                    <v-input
                      id="schedule"
                      name="schedule"
                      @input="val => diffusion.schedule = val"
                      :model="diffusion.schedule"
                      placeholder="ex: De 14h à 20 h du mardi au samedi"
                      label="Horaires"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Horaires">
                    </v-input>
                  </div>
                  <div class="column is-4">
                    <v-input
                      id="contactTel"
                      name="contactTel"
                      @input="diffusion.contact_tel = $event"
                      :model="diffusion.contact_tel"
                      :errors-bag="errors"
                      :input-type="'tel'"
                      v-validate="'min:10'"
                      :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                      data-vv-value-path="val"
                      data-vv-as="Téléphone"
                      :has-addons="true">
                      <r-label
                        slot="label"
                        :is-required="false"
                        :label="'Téléphone'"
                        :value="diffusion.contact_tel"
                        :truncate="false">
                        <span
                          class="is-padding-left-xsmall"
                          v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                          <i class="fal fa-info-circle"></i>
                        </span>
                      </r-label>
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-square is-static is-border">
                          <span class="icon"><i class="fas fa-phone-office"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                  <div class="column is-4">
                    <r-label
                      :label="'Email'"
                      :is-required="false"
                      :value="diffusion.contact_email"></r-label>
                    <v-input
                      id="contact_email"
                      name="contact_email"
                      @input="val => diffusion.contact_email = val"
                      :model="diffusion.contact_email"
                      placeholder="ex: j.dupont@contact.fr"
                      label="Email"
                      :errors-bag="errors"
                      data-vv-value-path="val"
                      data-vv-as="Email"
                      :has-addons="true">
                      <p
                        class="control"
                        slot="addonLeft">
                        <a class="button is-square is-static is-border">
                          <span class="icon"><i class="fas fa-paper-plane"></i></span>
                        </a>
                      </p>
                    </v-input>
                  </div>
                  <div class="column is-12">
                    <address-input
                      :source="diffusion.contact_address"
                      :is-required="false"
                      :red-check="false"
                      @update="updateAddress">
                    </address-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="formActionsSticky is-bottom">
              <div class="has-background-white is-padding-top-small is-padding-bottom-small">
                <div class="columns is-centered">
                  <div
                    class="column is-4 is-3-widescreen"
                    v-if="!diffusion.enabled">
                    <button
                      type="button"
                      @click="saveDraft()"
                      class="button is-medium is-success is-uppercase is-fullwidth"
                      :disabled="!canEdit || diffusionLoading"
                      :class="{'is-loading':diffusionLoading}">
                      <span v-if="diffusionLoading"><i class="fas fa-spinner fa-spin"></i></span>
                      <span v-else>Enregistrer brouillon</span>
                    </button>
                  </div>
                  <div
                    class="column is-4 is-3-widescreen"
                    v-else>
                    <button
                      type="button"
                      @click="submitAnnonceModification()"
                      class="button is-medium is-success is-uppercase is-fullwidth"
                      :disabled="!canSubmit || diffusionLoading"
                      :class="{'is-loading':diffusionLoading}">
                      <span v-if="diffusionLoading"><i class="fas fa-spinner fa-spin"></i></span>
                      <span v-else>Publier modifications</span>
                    </button>
                  </div>
                  <div
                    class="column is-4 is-3-widescreen"
                    v-if="!diffusion.enabled">
                    <button
                      type="button"
                      @click="submitAnnonce()"
                      class="button is-medium is-success is-uppercase is-fullwidth"
                      :disabled="!canSubmit || diffusionLoading"
                      :class="{'is-loading':diffusionLoading}">
                      <span v-if="diffusionLoading"><i class="fas fa-spinner fa-spin"></i></span>
                      <span v-else>Publier Annonce</span>
                    </button>
                  </div>
                  <div
                    class="column is-4 is-3-widescreen"
                    v-else>
                    <button
                      type="button"
                      class="button is-medium is-danger is-uppercase is-fullwidth"
                      @click="stopAnnonce()">
                      <span>Stopper Annonce</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div v-if="panel === 'MINISITE' && paramsSite">
          <form action="#">
            <div class="is-padding has-background-white">
              <div class="title is-3 is-marginless">
                <h2 class="is-margin-bottom-xsmall">
                  Clé seo
                </h2>
              </div>
              <div class="columns is-multiline">
                <div class="column is-6">
                  <r-label
                    :label="'Google Analytics'"
                    :is-required="false"
                    :value="paramsSite.ga_id"></r-label>
                  <v-input
                    id="ga_id"
                    name="ga_id"
                    @input="val => paramsSite.ga_id = val"
                    :model="paramsSite.ga_id"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Google Analytics">
                  </v-input>
                </div>
                <div class="column is-6">
                  <r-label
                    :label="'Clé sendinblue'"
                    :is-required="false"
                    :value="paramsSite.sendinblue_client_key"></r-label>
                  <v-input
                    id="sendinblue_client_key"
                    name="sendinblue_client_key"
                    @input="val => paramsSite.sendinblue_client_key = val"
                    :model="paramsSite.sendinblue_client_key"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Clé sendinblue">
                  </v-input>
                </div>
              </div>
              <div class="is-margin-top title is-3 is-marginless">
                <h2 class="is-margin-bottom-xsmall">
                  Balise méta
                </h2>
              </div>
              <div class="columns is-multiline">
                <div class="column is-6">
                  <r-label
                    :label="'Balise titre'"
                    :has-helper="true"
                    :is-required="false"
                    :value="paramsSite.meta_title"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'7ILv7dhnim0SFqG84Pc2K8'">
                      <i class="fal fa-question-circle"></i>
                    </span>
                  </r-label>
                  <v-input
                    id="meta_title"
                    name="meta_title"
                    @input="val => paramsSite.meta_title = val"
                    :model="paramsSite.meta_title"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Balise titre">
                  </v-input>
                </div>
                <div class="column is-6">
                  <r-label
                    :label="'Balise description'"
                    :is-required="false"
                    :value="paramsSite.meta_description"
                    :truncate="false"></r-label>
                  <v-input
                    id="meta_description"
                    name="meta_description"
                    @input="val => paramsSite.meta_description = val"
                    :model="paramsSite.meta_description"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Balise description">
                  </v-input>
                </div>
                <div class="column is-6">
                  <r-label
                    :label="'Titre de la page'"
                    :is-required="false"
                    :value="paramsSite.page_title"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'2VUlCE6HrjtK6TMSmHjQBd'">
                      <i class="fal fa-question-circle"></i>
                    </span>
                  </r-label>
                  <v-input
                    id="page_title"
                    name="page_title"
                    @input="val => paramsSite.page_title = val"
                    :model="paramsSite.page_title"
                    :errors-bag="errors"
                    data-vv-value-path="val"
                    data-vv-as="Titre de la page">
                  </v-input>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <r-label
                      :is-required="false"
                      :label="'Sous-origine du site public'"
                      :value="siteOrigin"
                      :truncate="false">
                      <span
                        class="is-padding-left-xsmall"
                        v-helper.right="'73TzUCLSOsrNzSfus334IG'">
                        <i class="fal fa-question-circle"></i>
                      </span>
                    </r-label>
                    <div
                      class="control"
                      v-if="originsList">
                      <multiselect
                        id="origin-contact"
                        class="multiselect--option-ico"
                        name="origin-contact"
                        group-values="children"
                        group-label="name"
                        v-model="siteOrigin"
                        :options="activeOriginGroups"
                        :multiple="false"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        :placeholder="''"
                        :custom-label="originName"
                        track-by="pk"
                        @search-change="getOrigins">
                        <template
                          slot="clear"
                          slot-scope="props">
                          <div
                            class="multiselect__clear"
                            v-if="originsList.length"
                            @mousedown.prevent.stop="clearAll(props.search)"></div>
                        </template>
                        <span
                          slot="placeholder"
                          class="multiselect__placeholder">Sélectionnez un utilisateur</span>
                        <span slot="noOptions">La liste est vide</span>
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="formActionsSticky is-bottom">
              <div class="has-background-white is-padding-top-small is-padding-bottom-small">
                <div class="columns is-centered">
                  <div
                    class="column is-4 is-3-widescreen"
                    v-if="!paramsSite.enabled">
                    <button
                      type="button"
                      @click="saveSiteDraft()"
                      class="button is-medium is-success is-uppercase is-fullwidth">
                      <span>Enregistrer brouillon</span>
                    </button>
                  </div>
                  <div
                    class="column is-4 is-3-widescreen"
                    v-else>
                    <button
                      type="button"
                      @click="submitSiteModification()"
                      class="button is-medium is-success is-uppercase is-fullwidth">
                      <span>Publier modifications</span>
                    </button>
                  </div>
                  <div
                    class="column is-4 is-3-widescreen"
                    v-if="!paramsSite.enabled">
                    <button
                      type="button"
                      @click="submitSite()"
                      class="button is-medium is-success is-uppercase is-fullwidth"
                      :disabled="siteLoading"
                      :class="{'is-loading':siteLoading}">
                      <span v-if="siteLoading"><i class="fas fa-spinner fa-spin"></i></span>
                      <span v-else>Publier Mini site</span>
                    </button>
                  </div>
                  <div
                    class="column is-4 is-3-widescreen"
                    v-else>
                    <button
                      type="button"
                      class="button is-medium is-danger is-uppercase is-fullwidth"
                      @click="stopSite()">
                      <span>Stopper Mini site</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { concat } from 'lodash'
import moment from 'moment'
import { Upload } from '@/mixins'

const emptyOffer = {
  reference: null,
  name: null,
  abstract: null,
  description: null,
  start_date: null,
  end_date: null
}

const emptyDiffusion = {
  add_program_descriptions: false,
  contact: null,
  contact_address: {},
  contact_email: null,
  contact_tel: null,
  enabled: false,
  end_date: null,
  long_description: null,
  offers: [],
  pictures: [],
  schedule: null,
  short_description: null,
  start_date: null,
  supports: []
}

const striptags = require('striptags')

export default {
  name: 'ProgramDiffusionEdit',
  mixins: [Upload],
  data () {
    return {
      addedSupports: [],
      loadingImg: false,
      originsList: [],
      siteOrigin: null,
      siteLoading: false,
      diffusionLoading: false,
      hasProgramDescriptions: false,
      program: null,
      diffusion: null,
      paramsSite: null,
      loading: false,
      panel: 'MULTIDIFF',
      pictures: [],
      offers: [],
      annonceStopped: false,
      siteStopped: false,
      submitModification: false,
      siteModification: false,
      hasSupports: false
    }
  },
  computed: {
    ...mapState(['origins']),
    ...mapGetters(['originsParent', 'originsChild', 'originGroups', 'activeOriginGroups', 'mgcEnabled']),
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    },
    canSubmit () {
      return 'short_description' in this.diffusion && this.diffusion.short_description && 'supports' in this.diffusion && this.diffusion.supports.length !== 0
    },
    canEdit () {
      return 'supports' in this.diffusion && this.diffusion.supports.length !== 0
    },
    originsChildMultidiff () {
      return this.originsChild.filter(x => x.multidiffusion)
    },
    originsdMultidiff () {
      return concat(this.originsChildMultidiff, this.addedSupports)
    },
    programPk () {
      return this.$route.params.id
    },
    datePlaceholder () {
      // ex: Septembre 2018
      return 'ex: ' + moment().format('MMMM YYYY')
    },
    seasonPlaceholder () {
      let seasons = {
        'Été': ['06', '07', '08'],
        'Hiver': ['12', '01', '02'],
        'Printemps': ['03', '04', '05'],
        'Automne': ['09', '10', '11']
      }
      let season = null
      for (let [key, value] of Object.entries(seasons)) {
        if (value.includes(moment().format('MM'))) {
          season = key
        }
      }
      return 'ex: ' + season + ' ' + moment().format('YYYY')
    }
  },
  async created () {
    this.diffusion = Object.assign({}, emptyDiffusion)
    await this.getProgram()
    await this.getDiffusion()
    if (!this.mgcEnabled) {
      this.changePanel('MINISITE')
    }
  },
  methods: {
    checkSupports () {
      this.$nextTick(() => {
        if (this.diffusion.supports.length) {
          this.hasSupports = true
        } else {
          this.hasSupports = false
        }
      })
    },
    addprogramDescription () {
      this.$toasted.global.success('Description incluse')
      let fullDescription = []
      if ('long_description' in this.diffusion && this.diffusion.long_description !== '' && this.diffusion.long_description !== null) {
        fullDescription.push(this.diffusion.long_description)
        fullDescription.push('\n')
      }
      for (let description of this.program.descriptions) {
        fullDescription.push(description.title)
        fullDescription.push('\n')
        let text = striptags(description.text, [])
        fullDescription.push(text.toString().replace(/&nbsp;/g, ' '))
      }
      this.$set(this.diffusion, 'long_description', fullDescription.join(''))
    },
    async getOrigins () {
      try {
        const { data } = await this.$api.get(this.$resources.ORIGIN, { sort: 'name:asc' })
        this.originsList = data.items
      } catch (e) {
        console.log(e)
      }
    },
    originName (origin) {
      if (origin.parent_name) {
        return origin.parent_name + ' - ' + origin.name
      } else {
        return origin.name
      }
    },
    async submitDiffusion () {
      this.diffusionLoading = true
      this.diffusion.offers = this.offers.slice()
      this.diffusion.pictures = this.pictures.slice()
      if (this.diffusion.start_date === '') {
        this.diffusion.start_date = null
      }
      if (this.diffusion.end_date === '') {
        this.diffusion.end_date = null
      }
      try {
        let { data } = await this.$api.axios.put(`programs/${this.program.pk}/mgc-params`, this.diffusion)
        let message = null
        let title = null
        let start = null
        let end = null
        if (data.enabled) {
          if (this.submitModification) {
            this.$toasted.global.success('Modification enregistrée. Votre annonce sera actualisée sur le ou les support(s) dans un délais pouvant aller jusqu\'a 12 heures')
            this.submitModification = false
          } else {
            title = 'Publication validée.'
            if (data.start_date) {
              start = moment(data.start_date).format('DD MMMM')
            }
            if (data.end_date) {
              end = moment(data.end_date).format('DD MMMM')
            }
            if (start && end) {
              message = `Votre annonce sera consultable sur le ou les support(s) dans la journée du ${start} au ${end}`
            } else if (start) {
              message = 'Votre annonce sera consultable sur le ou les support(s) à partir de la journée du ' + start
            } else if (end) {
              message = 'Votre annonce sera consultable sur le ou les support(s) jusqu\'au ' + end
            } else {
              let tomorow = moment().add(1, 'day').format('DD MMMM')
              message = 'Votre annonce sera consultable sur le ou les support(s) dans la journée du ' + tomorow
            }
            this.$toasted.global.success(title + '\n' + message)
          }
        } else if (this.annonceStopped) {
          this.$toasted.global.success('Publication stoppée')
          this.annonceStopped = false
        } else {
          this.$toasted.global.success('Annonce sauvegardée en tant que brouillon.')
        }
        this.diffusionLoading = false
      } catch (err) {
        console.log(err)
        this.diffusionLoading = false
      }
    },
    async submitParamsSite () {
      this.siteLoading = true
      if (this.siteOrigin) {
        this.paramsSite.origin = this.siteOrigin.pk
      }
      try {
        let { data } = await this.$api.axios.put(`programs/${this.program.pk}/site-params`, this.paramsSite)
        if (data.enabled) {
          if (this.siteModification) {
            this.$toasted.global.success('Modification enregistrée. Le site public sera actualisé dans les 10 prochaines minutes')
            this.siteModification = false
          } else {
            this.$toasted.global.success('Mini site publié.')
          }
        } else if (this.siteStopped) {
          this.$toasted.global.success('Mini site stoppé')
          this.siteStopped = false
        } else {
          this.$toasted.global.success('Mini site sauvegardé en tant que brouillon.')
        }
        this.siteLoading = false
      } catch (err) {
        console.log(err)
        this.siteLoading = false
      }
    },
    saveDraft () {
      this.diffusion.enabled = false
      this.submitDiffusion()
    },
    saveSiteDraft () {
      this.paramsSite.enabled = false
      this.submitParamsSite()
    },
    submitAnnonceModification () {
      this.submitModification = true
      this.diffusion.enabled = true
      this.submitDiffusion()
    },
    submitSiteModification () {
      this.siteModification = true
      this.paramsSite.enabled = true
      this.submitParamsSite()
    },
    submitAnnonce () {
      this.diffusion.enabled = true
      this.submitDiffusion()
    },
    submitSite () {
      this.paramsSite.enabled = true
      this.submitParamsSite()
    },
    stopAnnonce () {
      this.annonceStopped = true
      this.diffusion.enabled = false
      this.submitDiffusion()
    },
    stopSite () {
      this.siteStopped = true
      this.paramsSite.enabled = false
      this.submitParamsSite()
    },
    updateAddress (address) {
      this.$set(this.diffusion, 'contact_address', address)
    },
    async addProgramPictures () {
      this.loadingImg = true
      let urls = this.program.pictures.map(x => x.path)
      try {
        await this.setFusToken()
        let res = await this.$fus.clonedUrlList(urls)
        let hostedFiles = res.data.slice()
        hostedFiles = hostedFiles.map(x => {
          return {
            fus_id: x.id,
            cloudinary_id: x.cloudinary_id,
            cloudinary_version: x.cloudinary_version,
            path: x.path,
            filename: x.filename,
            display: x.display || true
          }
        })
        await this.uploadDocument({ files: hostedFiles })
        this.$toasted.global.success('Images ajoutées')
        this.loadingImg = false
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de l\'inclusion des images')
        this.loadingImg = false
      }
    },
    deleteDocuments (document) {
      let idx = this.pictures.findIndex(x => x.filename === document.filename)
      this.pictures.splice(idx, 1)
    },
    async changePanel (name) {
      this.loading = true
      await this.initPanel(name)
      this.panel = name
      this.loading = false
    },
    initPanel (name) {
      if (name === 'MINISITE') {
        this.getParamsSite()
        this.originsList = this.origins.slice()
      }
    },
    uploadDocument ({ files }) {
      files = files.filter(f => ['jpg', 'jpeg'].includes(f.filename.split('.').pop().toLowerCase()))
      if (files.cropped) {
        if ('filename' in files && (files.filename.toLowerCase().match(/brochure/) || files.filename.toLowerCase().match(/r?é?eservation/))) {
          let idx = this.pictures.findIndex(x => x.filename === files.filename)
          this.pictures.splice(idx, 1, files[0])
        } else {
          this.pictures.splice(files.croppedIndex, 1, files[0])
        }
      } else {
        files.forEach((file) => {
          let filename = 'Nouveau document'
          if (name) filename = name
          else if (file.filename) filename = file.filename
          let newFile = Object.assign({}, file, { filename })
          if (Array.isArray(this.pictures)) {
            this.pictures.push(newFile)
          } else {
            this.pictures = newFile
          }
        })
      }
    },
    async getProgram () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.PROGRAM, this.programPk)
        this.program = data
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    addOffer () {
      this.offers.push(Object.assign({}, emptyOffer))
    },
    removeOffer (index) {
      this.offers.splice(index, 1)
    },
    initDiffusion () {
      if ('pictures' in this.diffusion && this.diffusion.pictures) {
        this.pictures = this.diffusion.pictures.slice()
      }
      if ('offers' in this.diffusion && this.diffusion.offers) {
        this.offers = this.diffusion.offers.slice()
      } else {
        this.addOffer()
      }
      if (!('supports' in this.diffusion) || !this.diffusion.supports) {
        this.diffusion.supports = []
      } else {
        let supports = this.diffusion.supports.map(x => x.pk)
        let supportOriginsChildMultidiff = this.originsChildMultidiff.map(x => x.pk)
        for (let support of this.diffusion.supports) {
          if (!supportOriginsChildMultidiff.includes(support.pk)) {
            this.addedSupports.push(support)
          }
        }
        this.diffusion.supports = supports
      }
    },
    initSite () {
      if (this.paramsSite.origin) {
        this.siteOrigin = this.paramsSite.origin
      }
    },
    async getDiffusion () {
      this.loading = true
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_MGC_PARAMS(this.program.pk))
        this.diffusion = data
        this.initDiffusion()
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    async getParamsSite () {
      this.loading = true
      try {
        let { data } = await this.$api.get(this.$resources.PROGRAM_SITE_PARAMS(this.program.pk))
        this.paramsSite = data
        this.initSite()
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    }
  }
}
</script>
